import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { StyledMoreDetailsIcon } from "./PromptsComponent.styled";

interface IPromptCellProps {
    text: string;
}

export const PromptCell = ({ text }: IPromptCellProps) => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
    >
        <TruncatedTextWithTooltip
            fontVariant="input2"
            color={colorsPalettes.carbon[400]}
        >
            {text}
        </TruncatedTextWithTooltip>
        <StyledMoreDetailsIcon
            iconName="show-details"
            size="sm"
        />
    </Flex>
);
